//Languages constant
export const languages = {
  ARABIC: 'ar',
  BENGALI: 'bn',
  BULGARIAN: 'bg',
  CHINESE: 'zh',
  SIMPLIFIED_CHINESE: 'zh-cn',
  CZECH: 'cs',
  DUTCH: 'nl',
  ENGLISH: 'en',
  FRENCH: 'fr',
  FRENCH_CANADIAN: 'fr-ca',
  GERMAN: 'de',
  GUJARATI: 'gu',
  HINDI: 'hi',
  HUNGARIAN: 'hu',
  INDONESIAN: 'id',
  ITALIAN: 'it',
  JAPANESE: 'ja',
  JAVANESE: 'jv',
  KOREAN: 'ko',
  MALAY: 'ms',
  MARATHI: 'mr',
  NORWEGIAN: 'no',
  PERSIAN: 'fa',
  POLISH: 'pl',
  PORTUGUESE: 'pt',
  PUNJABI: 'pa',
  ROMANIAN: 'ro',
  RUSSIAN: 'ru',
  SINHALA: 'si',
  SLOVAK: 'sk',
  SLOVENIAN: 'sl',
  SPANISH: 'es',
  SWEDISH: 'sv',
  TAGALOG: 'tl',
  TAMIL: 'ta',
  TELUGU: 'te',
  THAI: 'th',
  TURKISH: 'tr',
  UKRAINIAN: 'uk',
  URDU: 'ur',
  VIETNAMESE: 'vi',
}

//Language options
export const languageOptions = [
  {
    value: languages.ENGLISH,
    label: 'English',
  },
  {
    value: languages.ARABIC,
    label: 'العربية (Arabic)',
  },
  {
    value: languages.BENGALI,
    label: 'বাংলা (Bengali)',
  },
  {
    value: languages.BULGARIAN,
    label: 'Български (Bulgarian)',
  },
  {
    value: languages.CHINESE,
    label: '繁體中文 (Traditional Chinese)',
  },
  {
    value: languages.SIMPLIFIED_CHINESE,
    label: '简体中文 (Simplified Chinese)',
  },
  {
    value: languages.CZECH,
    label: 'Čeština (Czech)',
  },
  {
    value: languages.DUTCH,
    label: 'Nederlands (Dutch)',
  },
  {
    value: languages.FRENCH,
    label: 'Français (French)',
  },
  {
    value: languages.FRENCH_CANADIAN,
    label: 'Français (Canada)',
  },
  {
    value: languages.GERMAN,
    label: 'Deutsch (German)',
  },
  {
    value: languages.GUJARATI,
    label: 'ગુજરાતી (Gujarati)',
  },
  {
    value: languages.HINDI,
    label: 'हिंदी (Hindi)',
  },
  {
    value: languages.HUNGARIAN,
    label: 'Magyar (Hungarian)',
  },
  {
    value: languages.INDONESIAN,
    label: 'Bahasa Indonesia (Indonesian)',
  },
  {
    value: languages.ITALIAN,
    label: 'Italiano (Italian)',
  },
  {
    value: languages.JAPANESE,
    label: '日本語 (Japanese)',
  },
  {
    value: languages.JAVANESE,
    label: 'ꦧꦱꦗꦮ (Javanese)',
  },
  {
    value: languages.KOREAN,
    label: '한국어 (Korean)',
  },
  {
    value: languages.MALAY,
    label: 'Bahasa Melayu (Malay)',
  },
  {
    value: languages.MARATHI,
    label: 'मराठी (Marathi)',
  },
  {
    value: languages.NORWEGIAN,
    label: 'Norsk (Norwegian)',
  },
  {
    value: languages.PERSIAN,
    label: 'فارسی (Persian)',
  },
  {
    value: languages.POLISH,
    label: 'Polski (Polish)',
  },
  {
    value: languages.PORTUGUESE,
    label: 'Português (Portuguese)',
  },
  {
    value: languages.PUNJABI,
    label: 'ਪੰਜਾਬੀ (Punjabi)',
  },
  {
    value: languages.ROMANIAN,
    label: 'Română (Romanian)',
  },
  {
    value: languages.RUSSIAN,
    label: 'Русский (Russian)',
  },
  {
    value: languages.SINHALA,
    label: 'සිංහල (Sinhala)',
  },
  {
    value: languages.SLOVAK,
    label: 'Slovenčina (Slovak)',
  },
  {
    value: languages.SLOVENIAN,
    label: 'Slovenščina (Slovenian)',
  },
  {
    value: languages.SPANISH,
    label: 'Español (Spanish)',
  },
  {
    value: languages.SWEDISH,
    label: 'Svenska (Swedish)',
  },
  {
    value: languages.TAGALOG,
    label: 'Filipino (Tagalog)',
  },
  {
    value: languages.TAMIL,
    label: 'தமிழ் (Tamil)',
  },
  {
    value: languages.TELUGU,
    label: 'తెలుగు (Telugu)',
  },
  {
    value: languages.THAI,
    label: 'ไทย (Thai)',
  },
  {
    value: languages.TURKISH,
    label: 'Türkçe (Turkish)',
  },
  {
    value: languages.UKRAINIAN,
    label: 'Українська (Ukrainian)',
  },
  {
    value: languages.URDU,
    label: 'اردو (Urdu)',
  },
  {
    value: languages.VIETNAMESE,
    label: 'Tiếng Việt (Vietnamese)',
  },
]

//Coats specific subset of language codes
const coatsLanguageCodes = [
  languages.ENGLISH,
  languages.SIMPLIFIED_CHINESE,
  languages.SPANISH,
  languages.VIETNAMESE,
  languages.INDONESIAN,
  languages.ARABIC,
  languages.TURKISH,
  languages.HUNGARIAN,
  languages.GERMAN,
  languages.ROMANIAN,
  languages.THAI,
  languages.URDU,
  languages.ITALIAN,
  languages.FRENCH,
  languages.POLISH,
]

//Coats specific language options (filtered from the full list)
export const coatsLanguageOptions = languageOptions
  .filter(option => coatsLanguageCodes.includes(option.value))

//Reply keywords that resume a paused enrollment, keyed by locale. The in-app
//messenger posts messages straight to the messages endpoint, which (unlike the
//SMS/WhatsApp channel pipeline) does not parse reply keywords, so the client
//detects these to trigger the resume action explicitly (see DEV-25493).
//Each locale may have more than one accepted keyword (e.g. synonyms).
export const enrollmentResumeKeywordsByLanguage = {
  [languages.ARABIC]: ['استأنف', 'متابعة', 'استمر'],
  [languages.BENGALI]: ['পুনরায় শুরু করুন', 'চালিয়ে যান', 'আবার শুরু'],
  [languages.BULGARIAN]: ['ПРОДЪЛЖИ', 'ПРОДЪЛЖЕТЕ', 'ПРОДЪЛЖАВАЙ'],
  [languages.CHINESE]: ['继续', '重新开始', '恢复'],
  [languages.SIMPLIFIED_CHINESE]: ['继续', '重新开始', '恢复'],
  [languages.CZECH]: ['POKRAČOVAT', 'OBNOVIT', 'ZNOVU'],
  [languages.DUTCH]: ['HERVATTEN', 'DOORGAAN', 'VERDER', 'VERDERGAAN'],
  [languages.ENGLISH]: ['RESUME', 'CONTINUE', 'RESTART'],
  [languages.FRENCH]: ['REPRENDRE', 'CONTINUER', 'RECOMMENCER'],
  [languages.FRENCH_CANADIAN]: ['REPRENDRE', 'CONTINUER', 'RECOMMENCER'],
  [languages.GERMAN]: ['FORTSETZEN', 'WEITER', 'WEITERMACHEN'],
  [languages.GUJARATI]: ['ફરી શરૂ', 'ચાલુ રાખો', 'આગળ વધો'],
  [languages.HINDI]: ['जारी रखें', 'फिर शुरू', 'पुनः आरंभ'],
  [languages.HUNGARIAN]: ['FOLYTATÁS', 'FOLYTASD', 'ÚJRAINDÍTÁS'],
  [languages.INDONESIAN]: ['LANJUTKAN', 'TERUSKAN', 'MULAI LAGI'],
  [languages.ITALIAN]: ['RIPRENDI', 'CONTINUA', 'RICOMINCIA'],
  [languages.JAPANESE]: ['再開', '続ける', 'また始める'],
  [languages.JAVANESE]: ['LANJUTAKE', 'TERUSAKE'],
  [languages.KOREAN]: ['재개', '계속', '다시 시작'],
  [languages.MALAY]: ['SAMBUNG', 'TERUSKAN', 'MULA SEMULA'],
  [languages.MARATHI]: ['पुन्हा सुरू', 'चालू ठेवा', 'पुढे चला'],
  [languages.NORWEGIAN]: ['GJENOPPTA', 'FORTSETT', 'BEGYNN IGJEN'],
  [languages.PERSIAN]: ['ادامه', 'از سر گیری', 'ادامه بده'],
  [languages.POLISH]: ['WZNÓW', 'KONTYNUUJ', 'ZACZNIJ OD NOWA'],
  [languages.PORTUGUESE]: ['RETOMAR', 'CONTINUAR', 'RECOMEÇAR'],
  [languages.PUNJABI]: ['ਦੁਬਾਰਾ ਸ਼ੁਰੂ', 'ਜਾਰੀ ਰੱਖੋ', 'ਅੱਗੇ ਵਧੋ'],
  [languages.ROMANIAN]: ['RELUAȚI', 'CONTINUAȚI', 'RELUARE'],
  [languages.RUSSIAN]: ['ВОЗОБНОВИТЬ', 'ПРОДОЛЖИТЬ', 'НАЧАТЬ СНОВА'],
  [languages.SINHALA]: ['නැවත ආරම්භ', 'ඉදිරියට යන්න', 'දිගටම යන්න'],
  [languages.SLOVAK]: ['POKRAČOVAŤ', 'OBNOVIŤ', 'ZNOVA'],
  [languages.SLOVENIAN]: ['NADALJUJ', 'NADALJEVANO', 'ZAČNI ZNOVA'],
  [languages.SPANISH]: ['REANUDAR', 'CONTINUAR', 'SEGUIR', 'RETOMAR', 'COMENZAR'],
  [languages.SWEDISH]: ['ÅTERUPPTA', 'FORTSÄTT', 'BÖRJA IGEN'],
  [languages.TAGALOG]: ['IPAGPATULOY', 'MAGPATULOY', 'ITULOY'],
  [languages.TAMIL]: ['மறுதொடக்கம்', 'மீண்டும் தொடங்கு', 'தொடரவும்'],
  [languages.TELUGU]: ['తిరిగి ప్రారంభించు', 'కొనసాగించు', 'మళ్ళీ ప్రారంభించు'],
  [languages.THAI]: ['ดำเนินการต่อ', 'เริ่มต้นใหม่', 'ต่อ'],
  [languages.TURKISH]: ['DEVAM', 'DEVAM ET', 'YENIDEN BAŞLA'],
  [languages.UKRAINIAN]: ['ПРОДОВЖИТИ', 'ВІДНОВИТИ', 'ПОЧАТИ ЗНОВУ'],
  [languages.URDU]: ['دوبارہ شروع کریں', 'جاری رکھیں', 'آگے بڑھیں'],
  [languages.VIETNAMESE]: ['TIẾP TỤC', 'BẮT ĐẦU LẠI', 'TIẾP TỤC LẠI'],
}
